import { render } from "./index.vue?vue&type=template&id=4172731d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/PlanCard/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4172731d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4172731d', __exports__)) {
    api.reload('4172731d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4172731d", () => {
    api.rerender('4172731d', render)
  })

}


export default __exports__